import { reactive, computed, App } from 'vue';
import type { Config, Meta } from '@/types/interfaces/config';
import { ConfigKey, CurrencyKey, MetaKey } from '@/types/symbols';
import { DEFAULT_CONFIG } from '../constants/default-config';

export const configState = reactive<Config>(DEFAULT_CONFIG);

export const metaState = computed<Meta>(() => configState.meta);
export const timezone = computed(() => configState.meta.timezone);
export const currency = computed(() => {
	return configState.meta.money.currencies[configState.meta.money.default]
		.symbol;
});
export const money = computed(() => {
	return configState.meta.money.currencies[configState.meta.money.default];
});
export const country = computed(() => {
	return configState.meta.country;
});

export const setConfig = (config: Config) => {
	Object.assign(configState, config);
	configState.meta = config.meta;
};

export const ConfigPlugin = {
	install(app: App, options?: { initial?: Config }) {
		if (options?.initial) {
			setConfig(options.initial);
		}

		app.provide(ConfigKey, configState);
		app.provide(MetaKey, metaState);
		app.provide(CurrencyKey, currency);

		app.config.globalProperties.$config = configState;
		app.config.globalProperties.$meta = metaState;
		app.config.globalProperties.$currency = currency;
	}
};
